import Swal from 'sweetalert2'
import {
    EDIT_MARK_TYPE, GET_SKILL, ADD_MARK_TYPE, IS_LOADING_GET_LIST_SKILLS, ADD_SKILL, GET_LIST_SKILLS, EDIT_SKILL, DELETE_SKILL, IS_LOADING_GET_LIST_MARK_TYPE, GET_LIST_MARK_TYPE, DELETE_MARK_TYPE,
    GET_MARK_TYPE, IS_LOADING_GET_LIST_CHAT_CATEGORIES, GET_LIST_CHAT_CATEGORIES, DELETE_CHAT_CATEGORY, GET_CHAT_CATEGORY, EDIT_COMMUNITY_CATEGORIE, IS_LOADING_GET_LIST_COMMUNITY_CATEGORIES,
    GET_LIST_COMMUNITY_CATEGORIES, GET_COMMUNITY_CATEGORY, DELETE_COMMUNITY_CATEGORY, IS_LOADING_GET_LIST_CLASSIFIED_CATEGORIES, ADD_CLASSIFIED_CATEGORIE,
    GET_LIST_CLASSIFIED_CATEGORIES, GET_CLASSIFIED_CATEGORY, EDIT_CLASSIFIED_CATEGORY, DELETE_CLASSIFIED_CATEGORY, IS_LOADING_GET_LIST_CLASSIFIED_SUBCATEGORIES, ADD_CLASSIFIED_SUBCATEGORIE,
    GET_LIST_CLASSIFIED_SUBCATEGORIES, GET_CLASSIFIED_SUBCATEGORY, EDIT_CLASSIFIED_SUBCATEGORY, DELETE_CLASSIFIED_SUBCATEGORY, IS_LOADING_GET_LIST_CLASSIFIED_STATUS, ADD_CLASSIFIED_STATUS,
    GET_LIST_CLASSIFIED_STATUS, EDIT_CLASSIFIED_STATUS, DELETE_CLASSIFIED_STATUS, GET_CLASSIFIED_STATUS, CREATE_CHAT_CATEGORIE, EDIT_CHAT_CATEGORIE, CREATE_COMMUNITY_CATEGORIE, IS_LOADING_GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES,
    CREATE_PROFESSIONAL_COMMUNITY_CATEGORIE, GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES, GET_PROFESSIONAL_COMMUNITY_CATEGORY, EDIT_PROFESSIONAL_COMMUNITY_CATEGORIE, DELETE_PROFESSIONAL_COMMUNITY_CATEGORY

} from './types'
import {
    urlServer
} from '../../config/GlobalConstant'
import inMemoryJWT from '../../auth/inMemoryJwt';
//// abilities to professional profile

export const createSkill = (skill, history) => async dispatch => {

    await fetch(`${urlServer}api/skill/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(skill)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_GET_LIST_SKILLS
                })
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: ADD_SKILL,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const seeListSkill = () => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_LIST_SKILLS
    });
    await fetch(`${urlServer}api/skill`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    

    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIST_SKILLS,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getSkill = (id, history) => async dispatch => {

    await fetch(`${urlServer}api/skill/get-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_SKILL,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const editSkill = (skill, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/skill/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(skill)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_SKILLS
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_SKILL,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deleteSkill = (id, index) => async dispatch => {

    await fetch(`${urlServer}api/skill/deleteAdmin`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_SKILLS
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_SKILL,
                    payload: index
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const unableSkill = (id, index) => async dispatch => {

    await fetch(`${urlServer}api/skill/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_SKILLS
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_SKILL,
                    payload: index
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

//// Types of mark, categories

export const createMarkType = (type, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/trademark/create-type`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(type)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_MARK_TYPE
                })
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: ADD_MARK_TYPE,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const seeListMarkType = (type, history) => async dispatch => {
     
    dispatch({
        type: IS_LOADING_GET_LIST_MARK_TYPE
    })
    await fetch(`${urlServer}api/trademark/get-types-brands`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIST_MARK_TYPE,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const deleteMarkType = (id, index) => async dispatch => {

    await fetch(`${urlServer}api/trademark/delete-type`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({
                type: IS_LOADING_GET_LIST_MARK_TYPE
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_MARK_TYPE,
                payload: index
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getMarkType = (id, history) => async dispatch => {

    await fetch(`${urlServer}api/trademark/get-type-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_MARK_TYPE,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const editMarkType = (typeEdited, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/trademark/update-type`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(typeEdited)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_MARK_TYPE
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_MARK_TYPE,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

////Type of categories of chats
export const createChatCategorie = (categorie, history) => async dispatch => {

    await fetch(`${urlServer}adminroomzonecategories/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(categorie)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_CHAT_CATEGORIES
                });
                dispatch({
                    type: CREATE_CHAT_CATEGORIE,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const seeListChatCategories = (history) => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_LIST_CHAT_CATEGORIES
    });
    await fetch(`${urlServer}adminroomzonecategories/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIST_CHAT_CATEGORIES,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const deleteChatCategorie = (id, index) => async dispatch => {

    await fetch(`${urlServer}adminroomzonecategories/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ categoryID: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_CHAT_CATEGORIES
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_CHAT_CATEGORY,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const removeChatCategorie = (id, index) => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_LIST_CHAT_CATEGORIES
    });
    await fetch(`${urlServer}chats/remove-category`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ chatCategoryID: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_CHAT_CATEGORY,
                payload: index
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getChatCategory = (id, history) => async dispatch => {

    await fetch(`${urlServer}chats/get-category-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ chatCategoryID: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_CHAT_CATEGORY,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const editChatCategory = (chatCategoryEdited, history, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}adminroomzonecategories/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(chatCategoryEdited)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_CHAT_CATEGORIES
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_CHAT_CATEGORIE,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}


//////Categorie of communities

export const createCommunityCategorie = (category, history) => async dispatch => {

    await fetch(`${urlServer}api/communities/createcategorycommunity`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(category)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                if (respJson.success === true) {
                    dispatch({
                        type: IS_LOADING_GET_LIST_COMMUNITY_CATEGORIES
                    });
                    dispatch({
                        type: CREATE_COMMUNITY_CATEGORIE,
                        payload: respJson.data
                    });
                }

            }

        })
        .catch(error => {
            console.log()
        })
}
export const seeListCommunityCategories = (isProfessional) => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_LIST_COMMUNITY_CATEGORIES
    });

    var url = isProfessional ? 'professionalcommunities' : 'communities'

    await fetch(`${urlServer}api/${url}/getallcategorycommunity`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            //'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIST_COMMUNITY_CATEGORIES,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getCommunityCategory = (id, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/communities/get/categoryId`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_COMMUNITY_CATEGORY,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}
export const editCommunityCategory = (communityCategoryEdited, history, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/communities/updatecategorycommunity`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(communityCategoryEdited)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.error === null) {
                dispatch({
                    type: IS_LOADING_GET_LIST_COMMUNITY_CATEGORIES
                });
                dispatch({
                    type: EDIT_COMMUNITY_CATEGORIE,
                    payload: { data: respJson.data, index: index }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}
export const deleteCommunityCategorie = (id, index) => async dispatch => {

    await fetch(`${urlServer}api/communities/deletecategorycommunity`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_COMMUNITY_CATEGORIES
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_COMMUNITY_CATEGORY,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

////Categories of classifieds


export const createClassifiedCategorie = (classified, history) => async dispatch => {

    await fetch(`${urlServer}api/classifieds/category-create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(classified)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_GET_LIST_CLASSIFIED_CATEGORIES
                })
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: ADD_CLASSIFIED_CATEGORIE,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}
export const seeListClassifiedCategories = (history) => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_LIST_CLASSIFIED_CATEGORIES
    })
    await fetch(`${urlServer}api/classifieds/categories`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
          
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            //'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIST_CLASSIFIED_CATEGORIES,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}
export const getClassifiedCategory = (id, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/category-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_CLASSIFIED_CATEGORY,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}
export const editClassifiedCategory = (classifiedCategoryEdited, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/category-update-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(classifiedCategoryEdited)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_CLASSIFIED_CATEGORIES
                })
                dispatch({
                    type: EDIT_CLASSIFIED_CATEGORY,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}
export const deleteClassifiedCategorie = (id, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/category-delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_CLASSIFIED_CATEGORIES
                })
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_CLASSIFIED_CATEGORY,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}


////Sucategories of classifieds


export const createClassifiedSubcategorie = (subcategory, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/subcategory-create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(subcategory)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_GET_LIST_CLASSIFIED_SUBCATEGORIES
                })
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: ADD_CLASSIFIED_SUBCATEGORIE,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}
export const seeListClassifiedSubcategorie = (id, history) => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_GET_LIST_CLASSIFIED_SUBCATEGORIES
    })
    await fetch(`${urlServer}api/classifieds/subcategories-category-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header   
        body: JSON.stringify(id)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIST_CLASSIFIED_SUBCATEGORIES,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}
export const getClassifiedSubcategorie = (id, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/subcategory-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_CLASSIFIED_SUBCATEGORY,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}
export const editClassifiedSubcategorie = (classifiedSubcategoryEdited, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/subcategory-update-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(classifiedSubcategoryEdited)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_CLASSIFIED_SUBCATEGORIES
                })
                dispatch({
                    type: EDIT_CLASSIFIED_SUBCATEGORY,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}
export const deleteClassifiedSubcategorie = (id, index) => async dispatch => {

    await fetch(`${urlServer}api/classifieds/subcategory-delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_GET_LIST_CLASSIFIED_SUBCATEGORIES
            })
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_CLASSIFIED_SUBCATEGORY,
                payload: index
            });
        })
        .catch(error => {
            console.log()
        })
}

////Status of classifieds


export const createClassifiedStatus = (status, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/status-create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(status)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_GET_LIST_CLASSIFIED_STATUS
                })
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: ADD_CLASSIFIED_STATUS,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const seeListClassifiedStatus = (category, history) => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_GET_LIST_CLASSIFIED_STATUS
    })
    await fetch(`${urlServer}api/classifieds/status`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            //'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, //
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIST_CLASSIFIED_STATUS,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getClassifiedStatus = (id, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/status-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_CLASSIFIED_STATUS,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const editClassifiedStatus = (classifiedSubcategoryEdited, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/status-update-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(classifiedSubcategoryEdited)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_CLASSIFIED_STATUS
                })
                dispatch({
                    type: EDIT_CLASSIFIED_STATUS,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deleteClassifiedStatus = (id, index) => async dispatch => {

    await fetch(`${urlServer}api/classifieds/status-delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_GET_LIST_CLASSIFIED_STATUS
            })
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_CLASSIFIED_STATUS,
                payload: index
            });
        })
        .catch(error => {
            console.log()
        })
}

// Categories for communities in professional
export const createProfessionalCommunityCategorie = (category, history) => async dispatch => {

    await fetch(`${urlServer}api/professionalcommunities/createcategorycommunity`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(category)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                if (respJson.success === true) {
                    dispatch({
                        type: IS_LOADING_GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES
                    });
                    dispatch({
                        type: CREATE_PROFESSIONAL_COMMUNITY_CATEGORIE,
                        payload: respJson.data
                    });
                }

            }

        })
        .catch(error => {
            console.log()
        })
}
export const seeListProfessionalCommunityCategories = (history) => async dispatch => {

    await fetch(`${urlServer}api/professionalcommunities/getallcategorycommunity`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            //'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}
export const searchListProfessionalCommunityCategories = (search, history) => async dispatch => {

    await fetch(`${urlServer}api/professionalcommunities/search/categories`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(search)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES,
                    payload: respJson.data.results
                });
            }
        })
        .catch(error => {
            console.log()
        })
}
export const getProfessionalCommunityCategory = (id, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/professionalcommunities/get/categoryId`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_PROFESSIONAL_COMMUNITY_CATEGORY,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}
export const editProfessionalCommunityCategory = (communityCategoryEdited, history, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/professionalcommunities/updatecategorycommunity`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(communityCategoryEdited)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.error === null) {
                dispatch({
                    type: IS_LOADING_GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES
                });
                dispatch({
                    type: EDIT_PROFESSIONAL_COMMUNITY_CATEGORIE,
                    payload: { data: respJson.data, index: index }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}
export const deleteProfessionalCommunityCategorie = (id, index) => async dispatch => {

    await fetch(`${urlServer}api/professionalcommunities/deletecategorycommunity`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_PROFESSIONAL_COMMUNITY_CATEGORY,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}